export const concernCategories = [
  {
    id: "skin",
    en: "SKIN",
    jp: "肌トラブルのお悩み",
    items: ["ニキビ", "シミ・くすみ", "毛穴"],
    icon: "ri-drop-line",
  },
  {
    id: "aging",
    en: "AGING / SKIN QUALITY",
    jp: "ハリ・肌質のお悩み",
    items: ["たるみ・シワ", "ハリ・ツヤ", "肌質改善"],
    icon: "ri-sparkling-line",
  },
  {
    id: "body",
    en: "BODY",
    jp: "ボディのお悩み",
    items: ["痩せたい", "部分痩せ"],
    icon: "ri-body-scan-line",
  },
  {
    id: "hair",
    en: "HAIR REMOVAL",
    jp: "ムダ毛のお悩み",
    items: ["ムダ毛をなくしたい"],
    icon: "ri-sparkling-2-line",
  },
  {
    id: "contour",
    en: "FACE / CONTOUR",
    jp: "輪郭・顔のお悩み",
    items: ["小顔・輪郭", "シワ・ボリューム"],
    icon: "ri-user-smile-line",
  },
  {
    id: "eyes",
    en: "EYES",
    jp: "目元のお悩み",
    items: ["二重・目元"],
    icon: "ri-eye-line",
  },
];